<mat-expansion-panel [disabled]="uploadInProgress" [expanded]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>STEP 3 - UPLOAD CONTRACT / APPROVE SITE</mat-panel-title>
    <mat-panel-description>
      <div *ngIf="stepComplete">
        <fa-icon [icon]="['fas', 'check']" class="green size-20"></fa-icon>
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <mat-divider></mat-divider>

  <div class="section-content">
    <div class="section-header">Site Contract</div>

    <div *ngIf="site.contractEnvelopeId === null" class="instructions">
      <span>Upload the signed contract and set site status to Active</span>
    </div>
    <div *ngIf="site.contractEnvelopeId !== null" class="instructions">
      <span *ngIf="site.status === StatusEnum.CONTRACT_SENT">
        The contract has been sent via DocuSign to the landowner and is pending signature.
      </span>
      <span *ngIf="site.status === StatusEnum.LANDOWNER_CONTRACT_SIGNED">
        The contract has been signed by the landowner via DocuSign and is pending FC representative signature.
      </span>
      <span *ngIf="site.status === StatusEnum.CONTRACT_SIGNED">
        Please review the signed contract in Documents tab and approve the site.
      </span>
      <span *ngIf="site.status === StatusEnum.CONTRACT_REJECTED" class="rejected">
        Landowner has rejected the site contract.
      </span>
      <span *ngIf="site.status !== StatusEnum.CONTRACT_REJECTED">Or upload signed contract manually</span>
    </div>
    <div class="upload-button">
      <button (click)="selectDocument()" *ngIf="isCurrentStep" mat-button type="button">
        <fa-icon [icon]="['far', 'upload']" class="blue"></fa-icon>
        <div class="fc-link">Upload Signed Contract</div>
      </button>
      <div *ngIf="fileUploadMessage">{{ fileUploadMessage }}</div>
    </div>

    <mat-divider></mat-divider>

    <div class="button-row">
      <button
        (click)="resendContract()"
        *ngIf="
          isCurrentStep &&
          !(site.status === StatusEnum.CONTRACT_SIGNED || site.status === StatusEnum.LANDOWNER_CONTRACT_SIGNED)
        "
        color="primary"
        mat-stroked-button>
        Resend Contract via Docusign
      </button>
      <button
        (click)="onActivated()"
        *ngIf="isCurrentStep"
        [class.disabled]="uploadInProgress"
        [disabled]="uploadInProgress"
        class="button button-container-2"
        color="primary"
        mat-raised-button>
        Activate Site
      </button>
    </div>
  </div>

  <input #documentUpload accept="*" id="documentUpload" name="documentUpload" style="display: none" type="file" />
</mat-expansion-panel>
